import {
    ADD_LOCAL_STORED_BETS,
    DECREMENT_BET_VALUE,
    INCREMENT_BET_VALUE,
    REMOVE_ALL_BETS,
    REMOVE_OPEN_BET,
    TOGGLE_COMMIT_BETS_ERROR,
    TOGGLE_COMMIT_BETS_SUCCESS,
    TOGGLE_COMMITTING_BETS,
    UNDO_LAST_BET_ACTION
} from '../constants/actionTypes';
import {getOpenBet} from '../helpers/betHelpers';
import {WARNING_NOTIFICATION} from '../../../constants/identifiers';
import {isLocalStorageAvailable, isLocalStorageQuotaExceeded} from '../../../helpers/systemHelpers';

export function incrementBetValue(bet, value, openBetsList) {
    let betHistory = {
        actionType: INCREMENT_BET_VALUE,
        value,
        game: bet.game,
        event: bet.event,
        racers: bet.racers,
        market: bet.market
    };
    return {type: INCREMENT_BET_VALUE, bet, betHistory, value};
}

export function undoLastBetAction(betHistory, openBetsList, eventId, channel) {
    if (betHistory && betHistory.length) {
        let currEventBetHistory = betHistory.filter((bh) => bh.event.eventId === eventId && bh.game.channel === channel);
        if (currEventBetHistory && currEventBetHistory.length) {
            let lastBetAction = currEventBetHistory[currEventBetHistory.length - 1];

            // get the open bet reffering to the last history actions
            let openBet = getOpenBet(lastBetAction.game, lastBetAction.event, lastBetAction.market, lastBetAction.racers, openBetsList);

            if (openBet) {
                switch (lastBetAction.actionType) {
                    case INCREMENT_BET_VALUE:
                        return {type: DECREMENT_BET_VALUE, openBet, eventId, channel};
                    default:
                        break;
                }
            }
        }
    }
    return {type: UNDO_LAST_BET_ACTION}; // this is done only for authentication checking on the middleware
}

export function removeOpenBet(openBet) {
    return {type: REMOVE_OPEN_BET, bet: openBet};
}

export function removeAllBets() {
    return {type: REMOVE_ALL_BETS};
}

export function toggleCommitBetsSuccess(gameChannel) {
    return {type: TOGGLE_COMMIT_BETS_SUCCESS, gameChannel};
}

export function toggleCommitBetsError(gameChannel) {
    return {type: TOGGLE_COMMIT_BETS_ERROR, gameChannel};
}

export function toggleCommittingBets(gameChannel) {
    return {type: TOGGLE_COMMITTING_BETS, gameChannel};
}

export function addSimplifiedLocalStoredBets(playerUID, noMoreBetsEventList) {
    if (!isLocalStorageAvailable) {
        // there is nothing to store if localStorage is not available
        console.warn('Browser local storage disabled, open bets cannot be cached.');
        return;
    }

    let localOpenBets = localStorage.getItem('OPEN_BETS');
    if (localOpenBets === null) {
        localOpenBets = {};
    } else {
        localOpenBets = JSON.parse(localOpenBets);
    }

    if (localOpenBets[playerUID] === undefined || localOpenBets[playerUID].openBetsList.length === 0 || localOpenBets[playerUID].openBetsHistory.length === 0) {
        return {type: 'IGNORE'};
    } else {
        let currDate = new Date();
        let openBetsList = localOpenBets[playerUID].openBetsList.filter(
            (obl) => obl.event.eventTimeDate > currDate.getTime() && !noMoreBetsEventList.find((nmbe) => nmbe.eventId === obl.event.eventId)
        );
        let openBetsHistory = localOpenBets[playerUID].openBetsHistory.filter(
            (obh) => obh.event.eventTimeDate > currDate.getTime() && !noMoreBetsEventList.find((nmbe) => nmbe.eventId === obh.event.eventId)
        );

        // we have to make sure the bets that belong to past events must not be committed therefore, the user should be warned of
        // this
        if (localOpenBets[playerUID].openBetsList.length !== openBetsList.length || localOpenBets[playerUID].openBetsHistory.length !== openBetsHistory.length) {
            window.GAME.notifyPlayer(WARNING_NOTIFICATION, WARNING_NOTIFICATION, 'OPEN_BETS_WARNING');
            localOpenBets[playerUID].openBetsList = openBetsList.slice();
            localOpenBets[playerUID].openBetsHistory = openBetsHistory.slice();

            try {
                localStorage.setItem('OPEN_BETS', JSON.stringify(localOpenBets));
            } catch (e) {
                if (isLocalStorageQuotaExceeded(e)) { // storage full
                    console.warn('Browser local storage is full, open bets cannot be cached.');
                }
            }
        }

        return {type: ADD_LOCAL_STORED_BETS, openBetsList, openBetsHistory}
    }
}



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/actions/openBetsActions.js